import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
  font-family: ${(props) => props.normalStyle.fontFamily};
  font-size: ${(props) => props.normalStyle.fontSize};
  font-weight: ${(props) => props.normalStyle.fontWeight};
  color: ${(props) => props.normalStyle.color || '#267CAA'};

  box-sizing: border-box;
  border-color: ${(props) => props.normalStyle.borderColor || ''};
  border-radius: ${(props) => props.normalStyle.borderRadius || '0'};
  box-shadow: 0 0 0 ${(props) => props.normalStyle.borderWidth}
    ${(props) => props.normalStyle.borderColor};

  padding-top: ${(props) => props.normalStyle.paddingTop || '0.5rem'};
  padding-bottom: ${(props) => props.normalStyle.paddingBottom || '0.5rem'};
  padding-left: ${(props) => props.normalStyle.paddingLeft || '0.5rem'};
  padding-right: ${(props) => props.normalStyle.paddingRight || '0.5rem'};

  .DayPicker-Day--selected & {
    border-radius: ${(props) => props.selectedStyle.borderRadius || '0'};
    border-color: ${(props) => props.selectedStyle.borderColor || '#267CAA'};
    box-shadow: 0 0 0 ${(props) => props.selectedStyle.borderWidth}
      ${(props) => props.selectedStyle.borderColor};

    background-color: ${(props) => props.selectedStyle.backgroundColor || ''};
    font-size: ${(props) => props.selectedStyle.fontSize};
    font-weight: ${(props) => props.selectedStyle.fontWeight};
    color: ${(props) => props.selectedStyle.color || '#267CAA'};
  }

  .DayPicker-Day--outside & {
    /* None for now */
  }

  .DayPicker-Day--disabled & {
    border-color: ${(props) => props.disabledStyle.borderColor || 'none'};
    border-radius: ${(props) => props.disabledStyle.borderRadius || '0'};
    box-shadow: 0 0 0 ${(props) => props.disabledStyle.borderWidth || 'none'}
      ${(props) => props.disabledStyle.borderColor || ''};

    font-family: ${(props) =>
      props.disabledStyle.fontFamily || props.normalStyle.fontFamily};
    font-size: ${(props) =>
      props.disabledStyle.fontSize || props.normalStyle.fontSize};
    font-weight: ${(props) =>
      props.disabledStyle.fontWeight || props.normalStyle.fontWeight};
    color: ${(props) => props.disabledStyle.color || '#ccc'};
  }
`;

const Day = ({ normalStyle, disabledStyle, selectedStyle, ...props }) => (
  <StyledDiv
    {...props}
    normalStyle={normalStyle}
    disabledStyle={disabledStyle}
    selectedStyle={selectedStyle}
  />
);

Day.defaultProps = {
  normalStyle: {},
  disabledStyle: {},
  selectedStyle: {},
};

Day.propTypes = {
  ...StyledDiv.propTypes,
  normalStyle: PropTypes.shape({
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string,
    borderColor: PropTypes.string,
    paddingTop: PropTypes.string,
    paddingRight: PropTypes.string,
    paddingBottom: PropTypes.string,
    paddingLeft: PropTypes.string,
  }),
  disabledStyle: PropTypes.shape({
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.string,
    borderWidth: PropTypes.string,
  }),
  selectedStyle: PropTypes.shape({
    borderColor: PropTypes.string,
    borderRadius: PropTypes.string,
    backgroundColor: PropTypes.string,
  }),
};

export default Day;
